import { Box, Modal } from "kvweb-ui";
import ImageMigrating from "../../AdminMerchant/Components/ImageMigrating";
import { getSyncState } from "../../../services/api/retail/merchantInfoApi";
import { useEffect } from "react";
import { FNB_PLATFORM } from "../../../utils/constant";
import { useDispatch } from "react-redux";
import { setSyncData, setSyncStatus } from "../../../store/slices/branchSlice";
import { useAdminMerchantContext } from "../../../contexts/adminMerchant/adminMerchant.context";

const ModalSyncState: React.FC<{
  open: boolean;
  setOpen: (open: boolean) => void;
  processPercent?: number;
  setProcessPercent?: (percent: number) => void;
}> = ({ open, setOpen, processPercent, setProcessPercent }) => {
  const { updateRetail, retail } = useAdminMerchantContext();
  const dispatch = useDispatch();
  const fetchSyncStateFnb = async () => {
    try {
      const res = await getSyncState(FNB_PLATFORM);
      if (res.state === "synced") {
        setProcessPercent?.(100);
        let newBranchInfo = { ...retail?.branchInfo };
        newBranchInfo.is_show_popup_onboard_done = true;
        updateRetail({
          key: "branchInfo",
          value: newBranchInfo,
        });
        setProcessPercent?.(100);
        dispatch(setSyncStatus(false));
        dispatch(setSyncData(res));
        setOpen(false);
        return;
      }
      setProcessPercent?.(Number(res.progress));
    } catch (e) {}
  };

  useEffect(() => {
    if (!open) return;
    const intervalFetchBranch = setTimeout(() => {
      fetchSyncStateFnb();
    }, 1500);

    return () => {
      clearInterval(intervalFetchBranch);
    };
  }, [open]);

  useEffect(() => {
    if (!!processPercent && processPercent <= 100) {
      const timeOutSync = setTimeout(() => {
        fetchSyncStateFnb();
      }, 2000);

      return () => clearTimeout(timeOutSync);
    }
  }, [processPercent]);
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          position: "relative",
        }}
      >
        <ImageMigrating processPercent={processPercent || 0} />
      </Box>
    </Modal>
  );
};

export default ModalSyncState;
